import * as React from 'react';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import { toast } from 'react-toastify';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { stringIsNullOrEmpty, zeroIfNull } from '../Common/Utilities';
import Zoom from '@mui/material/Zoom';
import { httpGet } from '../../HttpRequestHandling/httpRequestHandler';
import EnhancedDataGrid from '../Common/EnhancedDataGrid'; import IconButton from '@mui/material/IconButton';
import RefreshIcon from '@mui/icons-material/Refresh';


const Transition = React.forwardRef(function Transition(props, ref) {
	return <Zoom in={true} ref={ref} {...props} />;
});

export class CostCodesLookup extends React.Component {
	constructor(props) {
		super(props);

		this.level2Key = null;
		this.level3Key = null;
		this.poCode = null;

		this.inProgress = false;

		this.state = {
			resType: null,
			data: [],
			rowData: null
		};
		this.refresh_clickHandler = this.refresh_clickHandler.bind(this);
		this.checkbox_clickHandler = this.checkbox_clickHandler.bind(this);
		this.close_clickHandler = this.close_clickHandler.bind(this);
	}
	getRefreshButton = () => {
		return <IconButton
			variant="contained"
			onClick={this.refresh_clickHandler}
			size="small"
			style={{ float: "right", zIndex: 1, marginTop: 10, display: 'none' }}>
			<RefreshIcon />
		</IconButton>;
	}

	refresh_clickHandler(event) {
		this.props.inProgress(true);

		let functionName = "getcostcode";
		let messageName = "Cost Codes";
		httpGet("/api/Adapter/getSyncData/" + functionName)
			.then(response => {
				var data = response.data;
				this.props.inProgress(false);
				if (data)
					toast.success(messageName + ' Fetched Successfully');
				else
					toast.error('Error fetching ' + messageName);

			}).catch((error) => {
				this.props.inProgress(false);
				toast.error('Error fetching ' + messageName);
			});
	}
	componentDidUpdate() {
		var that = this;

		if (this.props.info.level2Key !== this.level2Key || this.props.info.level3Key !== this.level3Key || this.props.info.poCode !== this.poCode) {
			this.level2Key = this.props.info.level2Key;
			this.level3Key = this.props.info.level3Key;
			this.poCode = this.props.info.poCode;

			this.inProgress = false;
			this.setState({ data: [], rowData: null });
		}

		if (this.props.info.openDialog && this.state.data.length === 0 && !this.inProgress) {
			this.inProgress = true;
			this.fetchRecords();
		}
		else if (zeroIfNull(this.props.info.resType) !== zeroIfNull(this.state.resType)) {
			var rowData = this.getRowData(this.props.info.resType);
			this.setState({ resType: this.props.info.resType, rowData: rowData });
		}
	}

	checkbox_clickHandler(event) {
		var rowData = this.getRowData(event.target.value);

		this.setState({ rowData: rowData });
	}

	close_clickHandler(event) {
		if (this.props.onClose) {
			this.props.onClose(event, this.state.rowData);
		}
	}

	fetchRecords() {
		if (this.state.data.length === 0) {
			var queryParams = [];
			if (!stringIsNullOrEmpty(this.props.info.level2Key)) queryParams.push("level2Key=" + encodeURIComponent(this.props.info.level2Key));
			if (!stringIsNullOrEmpty(this.props.info.level3Key)) queryParams.push("level3Key=" + encodeURIComponent(this.props.info.level3Key));
			if (!stringIsNullOrEmpty(this.props.info.poCode)) queryParams.push("poCode=" + encodeURIComponent(this.props.info.poCode));

			this.props.info.inProgress(true);

			httpGet("/api/lookup/costcodeslist" + (queryParams.length > 0 ? "?" + queryParams.join("&") : ""))
				.then((response) => {
					//var data = response.data;
					var data = response.data.map((e, i) => { let d = {...e,rowId:i}; return d; })
					var rowData = data[data.findIndex(d => d.resType === this.props.info.resType)];
					this.setState({ resType: this.props.info.resType, data: data, rowData: rowData });
					this.props.info.inProgress(false);
				}).catch((error) => {
					this.props.info.inProgress(false);

					toast.error('Error fetching Cost Codes Lookup');

					this.close_clickHandler();
				});
		}
	}

	getRowData(value) {
		var data = this.state.data;

		return data[data.findIndex(d => d.resType === parseInt(value))];
	}

	render() {
		//const cellStyle = { paddingLeft: 8, paddingRight: 28 };
		//const headerStyle = { textAlign: 'right' };

		return (
			<Dialog open={this.props.info.openDialog} TransitionComponent={Transition} fullWidth maxWidth="lg">
				<DialogTitle>
					Select Cost Codes
						</DialogTitle>
				<DialogContent>
					<div style={{ display: 'block', overflow: 'auto', width: '100%' }}>
						<EnhancedDataGrid rows={this.state.data}
							disableColumnMenu
							pagination
							pageSize={10}
							customcomponent={this.getRefreshButton()}
							columns={[
								{
									headerName:' ',
									field:'chkCostCode',
									width: 40,
									renderCell: rowData =>
										<Checkbox
											color="default"
											name="chk"
											checked={this.state.rowData != null && this.state.rowData !== undefined && rowData.row.resType === this.state.rowData.resType}
											value={rowData.row.resType}
											onClick={this.checkbox_clickHandler}
										/>
								},
								{
									headerName: 'Name',
									field: 'rTypeName',									
									flex: 0.5,
								},
								{
									headerName: 'Description',
									field: 'rTypeDescription',
									flex:1,
									
								},
								{
									headerName: 'Effective Date',
									field: 'effectiveDate',
									type: 'date',
									flex:1,
									valueGetter: ({ value }) => (value && new Date(value)),
								}
								
							]}
							getRowId={(row) =>row.rowId}
							disableSelectionOnClick
						/>
					</div>
				</DialogContent>
				<DialogActions>
					<Button autoFocus onClick={this.close_clickHandler} color="primary">
						Close
					</Button>
				</DialogActions>
			</Dialog>
		);
	}
}
